module.exports = __webpack_public_path__ + "static/media/AddBulkRequest.bcce2122.svg";